import { useEffect } from "react";
import { useForm, Form } from "../useForm";

import Input from "../../controls/Input";
import DatePickerInput from "../../controls/DatePickerInput";
import { prod } from "mathjs";

const inputClassName =
  "mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm";

const initialFValues = {
  name: "",
  address: "",
  product: "",
  employee_name: "",
};

export default function CampaignDetailsForm(props) {
  const { campaign, actionCall, loading } = props;

  const { values, setValues, handleInputChange } = useForm(
    initialFValues,
    false,
  );

  useEffect(() => {
    if (campaign) {
      setValues({
        name: campaign.name ?? "",
        address: campaign.address ?? "",
        product: campaign.product ?? "",
        employee_name: campaign.employee_name ?? "",
      });
    }
  }, [campaign, setValues]);

  const handleSubmit = (e) => {
    e.preventDefault();
    actionCall(campaign, values);
  };

  if (!campaign) {
    return null;
  }

  return (
    <Form
      classes="bg-white shadow-lg rounded-xl overflow-hidden"
      onSubmit={handleSubmit}
    >
      {/* Form Content */}
      <div className="px-6 py-8">
        {/* Store & Location Section */}
        <div className="mb-8">
          <h4 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-4 pb-2 border-b border-gray-200">
            Store & Location
          </h4>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            <div>
              <Input
                label="Store Name"
                name="name"
                onChange={handleInputChange}
                value={values.name}
                labelOn={true}
                type="text"
                className={inputClassName}
              />
            </div>
            <div>
              <Input
                label="Address"
                name="address"
                onChange={handleInputChange}
                value={values.address}
                labelOn={true}
                type="text"
                className={inputClassName}
                required={true}
              />
            </div>
          </div>
        </div>

        {/* Campaign Details Section */}
        <div className="mb-8">
          <h4 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-4 pb-2 border-b border-gray-200">
            Campaign Details
          </h4>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            <div>
              <Input
                label="Employee Name"
                name="employee_name"
                onChange={handleInputChange}
                value={values.employee_name}
                labelOn={true}
                type="text"
                className={inputClassName}
                required={true}
              />
            </div>
            <div>
              <Input
                label="Product"
                name="product"
                onChange={handleInputChange}
                value={values.product.name_en ?? ""}
                labelOn={true}
                type="text"
                className={inputClassName}
                disabled={true}
              />
              <p className="mt-1 text-xs text-gray-500">
                Product cannot be changed after campaign creation
              </p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-end gap-3 pt-6 border-t border-gray-200">
          <button
            type="submit"
            disabled={loading}
            className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50"
          >
            Save
          </button>
        </div>
      </div>
    </Form>
  );
}
